import React from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function CustomDialog({ children, onClose, ...props }) {
  return (
    <Dialog onClose={onClose} {...props}>
      {/* Close button in top-right corner */}
      {onClose && (
        <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            sx={{
              padding: 0.5, // reduces padding around the button
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {children}
    </Dialog>
  );
}
